import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";
import { listSearch } from "../../../shared/utils/pagination-search";

/**
 * @purpose Review entity types
 * @primary Entity types table
 * @persona danilo-tech
 */
export const Route = createFileRoute("/app/admin/fsm-workflows/entity-types/")({
  validateSearch: listSearch,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
